import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style, animate, keyframes, transition } from '@angular/animations';
import { ChatMessage, ChatHistory, ChatRole ,RequestToAssistant } from '../../models/chat.model';
import { BackendApiService } from '../../services/backend-api.service';
import { firstValueFrom } from 'rxjs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import { ViewportScroller } from "@angular/common";



// import Boostrup



@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],


  animations: [
    trigger('slideStatus', [
    transition('* => loading', [
      animate('6s', keyframes([
        style({ color: 'transperent', offset: 0}),
        style({ color: 'yellow', offset: 0.8}),
        style({ color: 'orange', offset: 1.0})
      ])),
    ]),
    transition('* => copy', [
      animate('2s', keyframes([
        style({ color: 'transperent', offset: 0}),
        style({ color: 'yellow', offset: 0.2}),
        style({ color: 'transperent', offset: 1.0})
      ]))
    ]),

    transition('* => loading', [
      animate('2s', keyframes([
        style({ color: '$accent-blue' }),
        style({ color: 'yellow' }),
        style({ color: 'orange' })
      ]))
    ]),
  ])

  ],




})
export class ChatComponent implements OnInit {


  // Holds the chat messages in memory

  status: 'loading' | 'copy' = 'loading';

  run(status: 'loading' | 'copy') {
    this.status = status;
  }


  chatHistory: ChatHistory = {
    messages: []
  };

  // Model for the input text
  newMessage: string = '';

  // Optional: If you want to handle multiple model IDs
  bomModelsIds: string[] = [];

  // Flag to handle loading states if desired
  isLoading: boolean = false;
  notification: string = '';


  constructor(private backendApiService: BackendApiService)
  {
    this.bomModelsIds = backendApiService.CurrentModelsIds;
  }

  ngOnInit(): void {
    // Optionally, load any existing state here
  }

  /**
   * Sends the user's message to the AI assistant.
   */
  async sendMessage(): Promise<void> {
    const trimmed = this.newMessage.trim();
    this.run('loading');

    if (!trimmed) {
      return;
    }



    // 1. Add user's message to the chat
    const userMsg: ChatMessage = {
      message: trimmed,
      role: ChatRole.User,
      timestamp: new Date().toISOString()
    };
    this.chatHistory.messages.push(userMsg);

    this.scrollToBottom();

    // 2. Prepare the request object
    const request: RequestToAssistant = {
      chatHistory: this.chatHistory,
      bomModelsIds: this.bomModelsIds
    };

    // 3. Clear the text input
    this.newMessage = '';
    this.isLoading = true;
    this.showNotification('Loading...');


    // 4. Call the AI Assistant
    try {
      // 4. Call the AI Assistant using async/await + firstValueFrom
      const response = await firstValueFrom(
        this.backendApiService.AskAiAssistant(request)
      );

      this.isLoading = false; // Stop loading

      if (response && response.isSuccess) {
        // Update chat history with server's new/combined messages
        const updatedHistory = response.result as ChatHistory;

        // Identify which messages are new Assistant messages
        // (For example, if there's exactly 1 new assistant message,
        // you can find it by comparing the old length to the new length)
        const oldLength = this.chatHistory.messages.length;
        this.chatHistory = updatedHistory;
        const newMessages = this.chatHistory.messages.slice(oldLength);

        // For each new assistant message, start the typing effect
        newMessages.forEach(msg => {
          if (msg.role.toString() ===  'Assistant') {
            this.typingEffect(msg)
            ;
          }
        });
        //Wait 5 seconds before scrolling to bottom
        setTimeout(() => {
          this.scrollToBottom();
        }, 2000);
        this.scrollToBottom();

      } else {
        // If it's not a success, add a message for the user
        const errorMsg: ChatMessage = {
          message: 'Sorry, I was unable to process your request.',
          role: ChatRole.Assistant,
          timestamp: new Date().toISOString(),
        };
         this.chatHistory.messages.push(errorMsg);
      }
    } catch (err) {
      this.isLoading = false; // Stop loading
      console.error('Error asking AI assistant:', err);
      this.showNotification('Error: Could not load data!');


      // Optionally show an Assistant error message in the chat
      const errorMsg: ChatMessage = {
        message: 'An unexpected error occurred. Please try again later.',
        role: ChatRole.Assistant,
        timestamp: new Date().toISOString(),
      };
      this.chatHistory.messages.push(errorMsg);
      this.scrollToBottom();


    }

  }

  /**
   * Clears the entire chat. Effectively starts a new dialog.
   */
  clearChat(): void {
    this.chatHistory.messages = [];
  }

  copyToClipboard(text: string) {
    // Modern approach: use navigator.clipboard
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log('Copied to clipboard');
        this.showNotification('Copied to clipboard!');
        this.run('copy');
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }

  showNotification(message: string, durationMs: number = 2000): void {
    this.notification = message;
    setTimeout(() => {
      // Clear after the given duration
      this.notification = '';
    }, durationMs);
  }



  /**
   * Helper to filter out DataStorage messages (so they don't show in UI).
   */
  get visibleMessages(): ChatMessage[] {
    return this.chatHistory.messages.filter(msg => msg.role.toString() !== "DataStorage");
  }

  typingEffect(message: ChatMessage) {
    // If displayedMessage doesn't exist yet, initialize it
    message.displayedMessage = '';

    const fullText = message.message;
    let idx = 0;
    const typingSpeed = 5; // ms per character (adjust to taste)

    const intervalId = setInterval(() => {
      // Add next character
      message.displayedMessage += fullText.charAt(idx);
      idx++;

      // If done, clear interval
      if (idx >= fullText.length) {
        clearInterval(intervalId);
      }
    }, typingSpeed);
  }



  handleKeyEvents(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault(); // Prevent a new line from being added
      this.sendMessage();
    }
    if (event.key === 'Delete') {
      this.clearChat();
    }


  }

  private scrollToBottom(): void {

    document.getElementById("bottom")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }







}
